export interface KeyValueModel {
    id?: number;
    name?: string | undefined;
}